import React, { useContext } from "react";
import { Modal, Input, Heading, Flex, Button, MNotification } from "@cisco/spaces-dash-lib-styleguide";
import { I18nContext } from "../../contexts/i18nContext";
import InputWithKeylist from "./input-with-keylist";

function EditMetadataPopup(props) {
  const i18n = useContext(I18nContext);
  const { showEditPopup, cancelEdit, editMetadata, isError, errorMessage, metadataToEditObj, isValidValue, onMetadataKeyForEditSelection, setMetadataToEditObj, metadataKeyList } = props;

  return (
    <Modal size="md" isOpen={showEditPopup}>
      <Flex direction="vertical" gap={12}>
        <Heading as="h2" size="primary" id="metadata-heading">
          {i18n.t("location-metadata-bulk.add-metadata-text")}
        </Heading>

        <Flex direction="vertical" gap={16}>
          {isError && errorMessage && <MNotification status="negative">{errorMessage}</MNotification>}

          <Flex gap={16} align="center">
            <div className="meta-component">
              <div className="selection-wrapper">
                <InputWithKeylist
                  onChange={(e) => {
                    onMetadataKeyForEditSelection(e);
                    isValidValue(e.target.value);
                  }}
                  value={metadataToEditObj?.key}
                  placeholder={i18n.t("location-metadata-bulk.key-text")}
                  label={i18n.t("location-metadata-bulk.key-text")}
                  metadataKeyList={metadataKeyList}
                  required
                />
              </div>
            </div>
            <div className="meta-component-value">
              <div className="user-input-wrp">
                <Input
                  label={i18n.t("location-metadata-bulk.value-text")}
                  value={metadataToEditObj?.values && metadataToEditObj.values[0]}
                  onChange={(event) => {
                    setMetadataToEditObj((prev) => ({
                      ...prev,
                      values: [event.target.value]
                    }));
                    isValidValue(event.target.value);
                  }}
                  placeholder={i18n.t("location-metadata-bulk.value-text")}
                  className="inputText-add input-text"
                  maxLength="100"
                  required
                />
              </div>
            </div>
          </Flex>
        </Flex>

        <Flex justify="flex-end">
          <Button.Group>
            <Button kind="tertiary" onClick={cancelEdit}>
              {i18n.t("business-location-details.cancel-text")}
            </Button>
            <Button onClick={editMetadata} id="metadata-save-button">
              {i18n.t("hierarchy-nodes.save-text")}
            </Button>
          </Button.Group>
        </Flex>
      </Flex>
    </Modal>
  );
}

export default EditMetadataPopup;
